import {createClient} from '@launchdarkly/js-client-sdk';

let instance;
let readyPromise;

function buildContext(user) {
  if (!user || user.key === undefined || user.key === null || user.key === '') {
    return {kind: 'user', anonymous: true};
  }
  return {...user, kind: user.kind || 'user', key: String(user.key)};
}

function buildClient(key, user, options) {
  instance = createClient(key || 'placeholder', buildContext(user), options);
  instance.on('change', () => {});
  readyPromise = instance.start().then(result => {
    if (result && result.status === 'failed') {
      throw result.error;
    }
    return instance;
  });
}

export default function client(key, user, options) {
  if (!instance) {
    buildClient(key || 'placeholder', user, options || {});
  } else if (user && instance.identify) {
    instance.identify(buildContext(user));
  }
  return instance;
}

export function reset() {
  instance = null;
  readyPromise = null;
}

export function promise() {
  return readyPromise || Promise.reject('Launch Darkly not initialised');
}
